<template>
  <div id="app">
    <!-- Renders pages via the router -->
    <router-view />
    <!-- Global footer with dynamic year and policy links -->
    <AppFooter />
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'App',
  components: {
    AppFooter
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
</style>
